import Analytic from "pages/authorized/Analytic";
import PageError from "components/layout/PageError";
import Rate from "pages/authorized/general/Rate";
import LiveTrack from "pages/authorized/general/LiveTrack";
import Organisation from "pages/authorized/general/Organisation";
import QRCode from "pages/authorized/settings/QRCode";
import Fumigation from "pages/authorized/enquiry/Fumigation";
import Report from "pages/authorized/report";
import PushNotification from "pages/authorized/settings/PushNotification";
import Commission from "pages/authorized/settings/Commission";
import Media from "pages/authorized/other/Media";
import User from "pages/authorized/user";
import UserData from "pages/authorized/user/Data";
import AccessControl from "pages/authorized/settings/AccessControl";
import Finance from "pages/authorized/finance";
import Payout from "pages/authorized/finance/Payout";
import Transaction from "pages/authorized/transaction";
import Subscription from "pages/authorized/waste/Subscription";
import SpecialPickup from "pages/authorized/waste/SpecialPickup";
import Zone from "pages/authorized/settings/Zone";
import Product from "pages/authorized/settings/Product";
import Collector from "pages/authorized/collector";
import CollectorData from "pages/authorized/collector/Data";
import Collection from "pages/authorized/general/Collection";
import Agent from "../pages/authorized/general/Agent";

export const REGISTRY = [
    {
        resource: "dashboard",
        icon: "bar-chart",
        label: "Dashboard",
        always: true,
        routes: [{ path: "/dashboard", exact: true, component: Analytic }],
    },
    {
        resource: "user",
        icon: "user",
        label: "Users",
        routes: [
            { path: "/user", exact: true, component: User },
            { path: "/user/:id", exact: true, component: UserData },
        ],
    },
    {
        resource: "waste",
        icon: "trash-2",
        label: "Wastes",
        children: [
            { path: "/waste/subscription", label: "Subscription", exact: true, component: Subscription },
            { path: "/waste/special-pickup", label: "Special Pickup", exact: true, component: SpecialPickup },
        ]
    },
    {
        resource: "waste",
        icon: "anchor",
        label: "Collection",
        routes: [
            { path: "/collection", exact: true, component: Collection },
        ],
    },
    {
        resource: "collector",
        icon: "truck",
        label: "Collectors",
        routes: [
            { path: "/collector", exact: true, component: Collector },
            { path: "/collector/:id", exact: true, component: CollectorData },
        ],
    },
    {
        resource: "finance",
        icon: "trending-up",
        label: "Finance",
        children: [
            { path: "/finance", label: "Overview", exact: true, component: Finance },
            { path: "/finance/transaction", label: "Transactions", exact: true, component: Transaction },
            { path: "/finance/payout", label: "Payout", exact: true, component: Payout },
        ],
    },
    {
        resource: "enquire",
        icon: "repeat",
        label: "Enquires",
        children: [{ path: "/enquires/fumigation", label: "Fumigation", exact: true, component: Fumigation }],
    },
    {
        resource: "report",
        icon: "info",
        label: "Reports",
        routes: [{ path: "/report", exact: true, component: Report }],
    },
    {
        resource: "media",
        icon: "rss",
        label: "Media",
        routes: [{ path: "/media", exact: true, component: Media }],
    },
    {
        resource: "rate",
        icon: "star",
        always: true,
        label: "Rating",
        routes: [{ path: "/rate", exact: true, component: Rate }],
    },
    {
        resource: "track",
        icon: "radio",
        always: true,
        label: "Live Tracking",
        routes: [{ path: "/track", exact: true, component: LiveTrack }],
    },
    {
        resource: "organisation",
        icon: "briefcase",
        label: "Organisation",
        routes: [{ path: "/organisation", exact: true, component: Organisation }],
    },
    {
        resource: "agent",
        icon: "truck",
        label: "Agents",
        routes: [{ path: "/agent", exact: true, component: Agent }],
    },
    {
        resource: "message",
        icon: "bell",
        label: "Push Notification",
        routes: [{ path: "/message", exact: true, component: PushNotification }],
    },
    {
        resource: "zone",
        icon: "globe",
        label: "Zones",
        routes: [{ path: "/zone", exact: true, component: Zone }],
    },
    {
        resource: "qr_code",
        icon: "camera",
        label: "QR Code",
        routes: [{ path: "/qrcode", exact: true, component: QRCode }],
    },
    {
        resource: "product",
        icon: "box",
        label: "Products",
        routes: [{ path: "/product", exact: true, component: Product }],
    },
    {
        resource: "commission",
        icon: "divide-square",
        label: "Commissions",
        routes: [{ path: "/commission", exact: true, component: Commission }],
    },
    {
        resource: "account",
        icon: "users",
        label: "Access Control",
        routes: [{ path: "/access_control", exact: true, component: AccessControl }],
    }
];

export const MENU_SECTIONS = [
    { label: "General", match: ["dashboard", "user", "waste", "collection", "collector", "finance", "enquire", "report", "agent", "media", "rate", "track", "organisation"] },
    { label: "Settings", match: ["zone", "qr_code", "product", "commission", "account", "message"] }
];

export const ERROR_ROUTE = { path: "/error", exact: true, component: PageError };
